import React, { useMemo, useRef, useEffect } from 'react';
import SimpleMDE from 'react-simplemde-editor';
import { marked } from 'marked';
import 'easymde/dist/easymde.min.css';
import './MarkdownEditor.css';

const MarkdownEditor = ({ value, onChange, placeholder = 'Enter markdown text...' }) => {
  const editorRef = useRef(null);

  const options = useMemo(() => {
    return {
      spellChecker: false,
      placeholder: placeholder,
      status: false,
      autofocus: false,
      sideBySideFullscreen: false,
      previewRender: (text) => {
        return marked(text);
      },
      toolbar: [
        'bold',
        'italic',
        'heading',
        '|',
        'quote',
        'unordered-list',
        'ordered-list',
        '|',
        'link',
        'image',
        '|',
        'preview',
        'side-by-side',
        'fullscreen',
        '|',
        'guide'
      ]
    };
  }, [placeholder]);

  return (
    <div className="markdown-editor-wrapper">
      <SimpleMDE
        ref={editorRef}
        value={value}
        onChange={onChange}
        options={options}
      />
    </div>
  );
};

export default MarkdownEditor;
